import { IUserWorkoutDetail, v1UserWorkoutDetailsGet } from '@ifit/gateway-wolf-dashboard-service';
import { useQuery, UseQueryResult } from 'react-query';
import { FIFTEEN_SECONDS, ONE_DAY } from '../../util/durations';
import { isClub } from '../../util/is-club';
import { useIsEmbedded } from '../selectors/use-is-embedded';
import { useSoftwareNumber } from '../selectors/use-software-number';
import { useUserId } from '../selectors/use-user-id';
import { useUseMetricUnits } from '../selectors/use-use-metric-units';
import { useLanguage } from '../selectors/use-language';

export function useUserWorkoutDetails(workoutIds: string[]): UseQueryResult<IUserWorkoutDetail[], Error> {
  const isEmbedded = useIsEmbedded();
  const softwareNumber = useSoftwareNumber();
  const isClubMachine = isClub(softwareNumber);
  const language = useLanguage();
  const userId = useUserId();
  const useMetricUnits = useUseMetricUnits();

  return useQuery<IUserWorkoutDetail[], Error>(
    ['user-workout-details', { userId, isClubMachine, workoutIds, useMetricUnits, language }],
    () =>
      v1UserWorkoutDetailsGet({ workoutIds, softwareNumber, isEmbedded, isClub: isClubMachine, headers: { language } }),
    { staleTime: FIFTEEN_SECONDS, cacheTime: ONE_DAY, enabled: Boolean(workoutIds && workoutIds.length > 0) }
  );
}
